(function() {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('sgPasswordStrengthCtrl', sgPasswordStrengthCtrl);

  sgPasswordStrengthCtrl.$inject = ['$scope', 'Labels'];

  function sgPasswordStrengthCtrl ($scope, Labels) {

    const vm = this;
    vm.LABELS = Labels;

    vm.password = {
      status: 'Invalid',
      value: '',
      meterWidth: 0,
      type: 'password',
      showPassword: {
        status: false,
        string: 'show password',
      },
      rules: {
          isValidLength: false,
          hasNumber: false,
          hasLetter: false,
          noSpecialChar: false
      }
    };


    const validatePassword = () => {
      // set password rules if valid or invalid using regex
      if (vm.password.value) {
        vm.password.rules.hasNumber = vm.password.value.match(/\d/) ? true : false;
        vm.password.rules.hasLetter = vm.password.value.match(/[A-z]/) ? true : false;
        vm.password.rules.isValidLength = vm.password.value.match(/^.{8,}$/) ? true : false;
        vm.password.rules.noSpecialChar = !vm.password.value.match(/[ ^&;{}=:/"]/) ? true : false;
      }
      vm.password.meterWidth = vm.getMeterWidth(vm.password);
      vm.password.status = vm.getStatus(vm.password);
    };

    vm.setDefault = function () {
      vm.password.rules.hasNumber = false;
      vm.password.rules.hasLetter = false;
      vm.password.rules.isValidLength = false;
      vm.password.rules.noSpecialChar = true;
      vm.password.meterWidth = 25;
    };

    // recalculate the meterWidth
    vm.getMeterWidth = (password) => {
      let property_count = 0;
      let valid_property_count = 0;
      let property;

      for (property in password.rules) {
        if (password.rules.hasOwnProperty(property)) {
          property_count = property_count + 1;
          if (password.rules[property]) {
            valid_property_count = valid_property_count + 1;
          }
        }
      }

      return (valid_property_count / property_count) * 100;
    };

    // get the password status
    vm.getStatus = (password) => {
      if (100 === password.meterWidth) {
        return true;
      }
      return false;
    };


    vm.onPasswordChange = () => {
      vm.setDefault();
      validatePassword();
    };

    vm.onBlur = () => {
      if (vm.password.status) {
        $scope.$emit('validPassword', vm.password);
      }
    };

    vm.onFocus = () => {
      vm.password.value = '';
      vm.setDefault();
      $scope.$emit('resetPassword');
    };

    vm.toggleShowPassword = () => {
      vm.password.showPassword.status = !vm.password.showPassword.status;
      vm.password.showPassword.string = vm.password.showPassword.status ? 'hide password' : 'show password';
    };
  }

})();
